<!-- hasta aca los cambios -->
<template>
    <v-container fluid class="cbc-analyzer-container">
        <!-- Barra de encabezado con datos del usuario -->
        <v-app-bar app color="white" dark>
            <v-img src="../../images/fishbone-logo.jpg" :min-width="isMobile ? 100 : 900" class="mr-4 logo"></v-img>

            <template v-if="isMobile">
                <v-btn icon @click="showPatientInfo = !showPatientInfo">
                    <v-icon>mdi-menu</v-icon>
                </v-btn>
            </template>

            <!-- Datos dinámicos (Edad, Género, Peso, Estatura, Etnia) -->
            <template v-else>
                <v-spacer></v-spacer>
                <v-btn @click="$router.push({ name: 'Dashboard' })" color="primary" class="mr-3">
                    <v-icon left>mdi-arrow-left</v-icon> <!-- Puedes usar otro icono si lo prefieres -->
                    Regresar
                </v-btn>
                <v-select v-model="selectedGender" :items="genders" label="Género" outlined dense :disabled="true"
                    class="mr-3"></v-select>
                <v-text-field v-model="age" label="Edad" outlined dense :disabled="true" class="mr-3"></v-text-field>
                <v-text-field v-model="weight" label="Peso (kgs)" outlined dense :disabled="true"
                    class="mr-3"></v-text-field>
                <v-text-field v-model="height" label="Estatura (cm)" outlined dense :disabled="true"
                    class="mr-3"></v-text-field>
                <v-select v-model="selectedEthnicity" :items="ethnicities" label="Etnia" outlined dense
                    :disabled="true"></v-select>
                <v-btn :href="'/'" color="primary" class="mr-3">
                    <v-icon left>mdi-logout</v-icon>
                    Salir
                </v-btn>
            </template>
        </v-app-bar>

        <v-navigation-drawer v-model="showPatientInfo" temporary right>
            <v-list>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title class="title">Datos del Paciente</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- Campos de datos -->
                <v-list-item>
                    <v-select v-model="selectedGender" :items="genders" label="Género" outlined dense
                        :disabled="true"></v-select>
                </v-list-item>
                <v-list-item>
                    <v-text-field v-model="age" label="Edad" outlined dense :disabled="true"></v-text-field>
                </v-list-item>
                <v-list-item>
                    <v-text-field v-model="weight" label="Peso (kgs)" outlined dense :disabled="true"></v-text-field>
                </v-list-item>
                <v-list-item>
                    <v-text-field v-model="height" label="Estatura (cm)" outlined dense :disabled="true"></v-text-field>
                </v-list-item>
                <v-list-item>
                    <v-select v-model="selectedEthnicity" :items="ethnicities" label="Etnia" outlined dense
                        :disabled="true"></v-select>
                </v-list-item>

            </v-list>
        </v-navigation-drawer>


        <!-- Cuerpo Principal -->
        <v-row class="mt-5">
            <!-- Publicidad Izquierda (Visible solo en pantallas grandes) -->
            <v-col cols="12" sm="1" class="advertisement left-ad" v-if="!isMobile">
            </v-col>

            <!-- Panel Principal -->
            <v-col :cols="isMobile ? 12 : 10">
                <v-row style="margin: 0;" class="flex-container">
                    <!-- Izquierda 70% -->
                    <v-col :cols="isMobile ? 12 : 7" class="principal">

                        <v-card class="analyzer-card" style="border-radius: 4em;">
                            <v-card-title class="text-center"
                                style="font-size:3em; font-family:Georgia, 'Times New Roman', Times, serif;">Lipid Panel
                                Analyzer</v-card-title>
                            <!-- Fishbone Analyzer Diagram -->

                            <div class="fishbone-container">
                                <v-row class="mt-4" align="center" :justify="isMobile ? 'end' : 'start'">
                                    <v-col cols="auto">
                                        <v-btn @click="call_Calculate" class="fishbone-input btn">
                                            10-Year ASCVD Risk
                                        </v-btn>

                                    </v-col>

                                </v-row>

                                <v-text-field v-model="fields.cholesterol" label="TC (mg/dL)" outlined dense
                                    class="fishbone-input cholesterol"></v-text-field>
                                <v-text-field v-model="fields.cholesterolhdl" label="HDL (mg/dL)" outlined dense
                                    class="fishbone-input cholesterolhdl"></v-text-field>
                                <v-text-field v-model="fields.triglycerides" label="TGs (mg/dL)" outlined dense
                                    class="fishbone-input triglycerides"></v-text-field>
                                <v-text-field v-model="fields.sbp" label="sbb (mm/Hg)" outlined dense
                                    class="fishbone-input sbp"></v-text-field>


                            </div>
                            <v-card class="mt-4 pa-4" outlined style="background-color: #c5972d;">
                                <v-row dense>
                                    <!-- Fumador -->
                                    <v-col cols="12" sm="4">
                                        <div class="text-subtitle-2 mb-2">Fumador</div>
                                        <v-btn-toggle v-model="smoker" mandatory class="toggle-group" tile>
                                            <v-btn :value="true" color="green">Sí</v-btn>
                                            <v-btn :value="false" color="red">No</v-btn>
                                        </v-btn-toggle>
                                    </v-col>

                                    <!-- Diabetes -->
                                    <v-col cols="12" sm="4">
                                        <div class="text-subtitle-2 mb-2">Diabetes</div>
                                        <v-btn-toggle v-model="diabetes" mandatory class="toggle-group" tile>
                                            <v-btn :value="true" color="green">Sí</v-btn>
                                            <v-btn :value="false" color="red">No</v-btn>
                                        </v-btn-toggle>
                                    </v-col>

                                    <!-- Presión Tratada -->
                                    <v-col cols="12" sm="4">
                                        <div class="text-subtitle-2 mb-2">Tratamiento para Presión Alta</div>
                                        <v-btn-toggle v-model="sbpTreated" mandatory class="toggle-group" tile>
                                            <v-btn :value="true" color="green">Sí</v-btn>
                                            <v-btn :value="false" color="red">No</v-btn>
                                        </v-btn-toggle>
                                    </v-col>
                                </v-row>
                            </v-card>

                            <v-btn @click="clearFields" color="yellow" class="mt-4" block>
                                Limpiar Campos
                            </v-btn>

                        </v-card>

                    </v-col>



                    <!-- Derecha 30% -->
                    <v-col :cols="isMobile ? 12 : 5" class="right-panel">
                        <v-card class="data-card" style="max-height:fit-content">
                            <v-card-title class="text-center"
                                style="background-color:transparent; font-size:2.5em ; color: white;">Diagnóstico</v-card-title>
                            <v-row dense style="align-items: center">
                                <v-col cols="12" v-for="(item, index) in additionalData" :key="index">
                                    <v-card class="data-box" outlined v-if="item.value">
                                        <v-card-actions>
                                            <!-- Botón que abre el banner -->
                                            <v-btn text color="primary" @click="openBanner(item.label, item.value);">
                                                Ver más detalles
                                            </v-btn>
                                        </v-card-actions>
                                        <v-card-text class="diagnosis-text">{{ item.label }}: {{ item.value
                                            }}</v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>

                            <!-- Dialogo para mostrar el "banner" -->
                            <v-dialog v-model="showBanner" max-width="600">
                                <v-card class="banner-card rounded-xl elevation-6 pa-4">
                                    <v-card-title class="text-h5 font-weight-bold pb-2">{{ selectedLabel
                                        }}</v-card-title>

                                    <v-card-text>
                                        <v-expansion-panels focusable inset>
                                            <v-expansion-panel v-for="(info, i) in bannerData" :key="i">
                                                <v-expansion-panel-header>
                                                    <span class="text-subtitle-1 font-weight-bold">{{ info.title
                                                        }}</span>
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content>
                                                    <v-list dense>
                                                        <v-list-item v-for="(detail, j) in info.details" :key="j"
                                                            class="py-1">
                                                            <v-list-item-content>
                                                                <v-list-item-title class="text-body-2">
                                                                    • {{ detail }}
                                                                </v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-card-text>

                                    <v-card-actions class="justify-end">
                                        <v-btn color="primary" variant="text" @click="showBanner = false">Cerrar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>

                            <v-card class="data-box" outlined v-if="infusionRate">
                                <v-card-text>Tasa de Infusión: {{ infusionRate }}</v-card-text>
                            </v-card>
                        </v-card>
                        <v-card v-if="ascvdResult !== null" class="mt-4 pa-4" color="orange lighten-4" elevation="2">
                            <v-card-title class="text-h6">Resultado del Riesgo ASCVD (10 años)</v-card-title>
                            <v-card-text>
                                <p>El riesgo estimado de enfermedad cardiovascular en los próximos 10 años es:</p>
                                <p><strong>{{ ascvdResult }}%</strong></p>
                                <p v-if="ascvdResult >= 7.5">
                                    Este resultado sugiere un <strong>riesgo alto</strong>. Podrían recomendarse medidas
                                    preventivas
                                    como
                                    estatinas o cambios en el estilo de vida.
                                </p>
                                <p v-else>
                                    Este resultado sugiere un <strong>riesgo bajo a moderado</strong>.
                                </p>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>



            <!-- Publicidad Derecha (Visible solo en pantallas grandes) -->
            <v-col cols="12" sm="1" class="advertisement right-ad" v-if="!isMobile">
            </v-col>
        </v-row>

        <!-- Publicidad Inferior -->
        <v-row class="advertisement botton-ad mt-4">
            <v-col cols="12">
            </v-col>
        </v-row>
    </v-container>
</template>

<!-- un cambio mas arriba -->
<script>
import { ref, onMounted } from 'vue';
import axios from 'axios';
const apiUrl = process.env.VUE_APP_API_URL;


export default {


    setup() {
        const parametros = ref({});
        const cargarParametros = async () => {
            try {
                const response = await axios.get(`${apiUrl}/api/parameters`);
                const data = response.data;
                const parametrosMap = {
                    cholesterol: { valorMostrado: '', valorAlto: '', valorBajo: '', units: '', rango: '' },
                    cholesterolhdl: { valorMostrado: '', valorAlto: '', valorBajo: '', units: '', rango: '' },
                    triglycerides: { valorMostrado: '', valorAlto: '', valorBajo: '', units: '', rango: '' }

                };

                data.forEach((param) => {
                    switch (param.parametro.toLowerCase()) {
                        case 'cholesterol':
                            parametrosMap.cholesterol = {
                                valorMostrado: param.valorMostrado,
                                valorAlto: param.valorAlto || '',   // Si no existe, se asigna un valor vacío
                                valorBajo: param.valorBajo || '',
                                units: param.units || '',
                                rango: param.rango || ''
                            };
                            break;
                        case 'cholesterolhdl':
                            parametrosMap.cholesterolhdl = {
                                valorMostrado: param.valorMostrado,
                                valorAlto: param.valorAlto || '',
                                valorBajo: param.valorBajo || '',
                                units: param.units || '',
                                rango: param.rango || ''
                            };
                            break;
                        case 'triglycerides':
                            parametrosMap.triglycerides = {
                                valorMostrado: param.valorMostrado,
                                valorAlto: param.valorAlto || '',
                                valorBajo: param.valorBajo || '',
                                units: param.units || '',
                                rango: param.rango || ''
                            };
                            break;

                    }
                });
                parametros.value = parametrosMap;


                localStorage.setItem('parametros', JSON.stringify(parametros.value));
            } catch {
                console.error('Error al cargar parámetros:', error);

            }
        };
        onMounted(() => {
            const savedParams = localStorage.getItem('parametros');
            if (savedParams) {
                parametros.value = JSON.parse(savedParams);
            }

            cargarParametros();
        });

        return { parametros };
    },

    data() {
        return {
            showBanner: false, // Estado del banner
            selectedLabel: "", // Etiqueta seleccionada
            bannerData: [], // Información detallada del banner
            showPatientInfo: false,
            aniongap: 0,
            fields: {
                cholesterol: '',
                cholesterolhdl: '',
                triglycerides: '',
                sbp: '',

            },
            selectedGender: null,
            age: null,
            weight: null,
            height: null,
            selectedEthnicity: null,
            etniaid: null,
            smoker: false,
            diabetes: false,
            sbpTreated: false,
            ascvdResult: null,
            diagnosisOne: '',
            diagnosisOneDesc: '',
            diagnosisPlt: '',
            diagnosisPltDesc: '',
            additionalData: [


                { label: 'Diagnóstico cholesterol', value: '' },
                { label: 'Diagnóstico cholesterol HDL', value: '' },
                { label: 'Diagnóstico triglycerides', value: '' },
                { label: 'Diagnostico LDL', value: '' },
                { label: 'Diagnostico Total Cholesterol/HDLCholesterol', value: '' },

            ],
            // Variables necesarias para la tasa de infusión
            genderVal: null,
            weightVal: null,
            ageVal: null,
            ivna: null,
            ivk: null,
            naChange: null,
            infusionRate: null, // Para guardar la tasa de infusión calculada
            individualDiagnoses: [], // Nuevo arreglo para guardar diagnósticos individuales

            diagnostico1: '',
            diagnostico2: ''
        };
    },
    computed: {

        isMobile() {
            return this.$vuetify.display.mdAndDown;
        },

        // Lógica para calcular diagnósticos según los valores
        diagnosis() {

            const cholesterol = this.convertToNumber(this.fields.cholesterol);
            const cholesterolhdl = this.convertToNumber(this.fields.cholesterolhdl);
            const triglycerides = this.convertToNumber(this.fields.triglycerides);




            this.additionalData[0].value = cholesterol ? this.evaluatecholesterol(cholesterol) : '';
            this.additionalData[1].value = cholesterolhdl ? this.evaluatecholesterolhdl(cholesterolhdl) : '';
            this.additionalData[2].value = triglycerides ? this.evaluatetriglycerides(triglycerides) : '';
            this.additionalData[3].value = this.evaluateLDL();
            this.additionalData[4].value = this.evaluateTotal();

        }

    },
    methods: {

        clearFields() {
            // Limpiar los campos de texto
            this.fields.cholesterol = '';
            this.fields.cholesterolhdl = '';
            this.fields.triglycerides = '';

            // Limpiar los datos dentro de additionalData
            this.additionalData.forEach(item => {
                if (item.label !== 'Diagnostico Primario' && item.label !== 'Diagnostico Secundario') {
                    item.value = ''; // Limpiar solo los valores de los otros campos
                }
            });

            // Hacer desaparecer "Diagnóstico Primario" y "Diagnóstico Secundario"
            const primary = this.additionalData.find(item => item.label === 'Diagnostico Primario');
            const secondary = this.additionalData.find(item => item.label === 'Diagnostico Secundario');
            if (primary) {
                primary.value = '';
            }
            if (secondary) {
                secondary.value = '';
            }
        },
        openBanner(label, value) {
            this.selectedLabel = label;
            this.showBanner = true;

            axios.get(`${apiUrl}/api/enfermedades/filter?enfermedad=${value}`)
                .then(response => {
                    const enfermedad = response.data[0]; // asumimos que es único

                    if (enfermedad) {
                        this.bannerData = [
                            {
                                title: "Differential Diagnosis",
                                details: enfermedad.descripcion
                                    ? enfermedad.descripcion.split('\n').map(str => str.trim()).filter(Boolean)
                                    : ["Sin descripción disponible"]
                            },
                            {
                                title: "Workup",
                                details: enfermedad.tratamiento
                                    ? enfermedad.tratamiento.split('\n').map(str => str.trim()).filter(Boolean)
                                    : ["Sin tratamiento disponible"]
                            },
                        ];
                    } else {
                        this.bannerData = [
                            {
                                title: "Información no encontrada",
                                details: ["No se encontró información en la base de datos para esta enfermedad."],
                            },
                        ];
                    }
                })
                .catch(error => {
                    console.error("Error al obtener los datos:", error);
                    this.bannerData = [
                        {
                            title: "Error",
                            details: ["Hubo un problema al consultar los datos de la base de datos."],
                        },
                    ];
                });
        },

        fieldLabel(field) {
            const labels = {
                cholesterol: 'cholesterol',
                cholesterolhdl: 'cholesterol HDL',
                triglycerides: 'triglycerides'
            };
            return labels[field] || field;
        },

        calcularLDL() {
            // Convertir los valores de los campos a números
            let LDL = 0;
            const cholesterolhdl = this.convertToNumber(this.fields.cholesterolhdl);
            const triglycerides = this.convertToNumber(this.fields.triglycerides);

            LDL = cholesterolhdl - (triglycerides / 5)

            if (triglycerides > 390) {
                return 'unable to calculate'
            }

            return LDL;
        },

        convertToNumber(value) {
            if (typeof value === 'string' && value.endsWith('K')) {
                return parseInt(value.slice(0, -1)) * 1000;
            }
            return parseFloat(value);
        },
        resetForm() {
            for (let field in this.fields) {
                this.fields[field] = ''; // Reset all fields to empty
            }
        },

        // Métodos de evaluación para cada campo

        evaluatecholesterol(cholesterol) {
            if (cholesterol < 200) return 'Normal';
            else if (cholesterol > 200) return 'High';

        },
        evaluatecholesterolhdl(cholesterolhdl) {
            if (cholesterolhdl > 50) return 'Normal';
            else if (cholesterolhdl < 50) return 'Low';

        },

        evaluatetriglycerides(triglycerides) {


            if (triglycerides < 150) return 'Normal';
            else if (triglycerides > 151 && triglycerides < 300) return 'Moderately High';
            else if (triglycerides > 301 && triglycerides < 900) return 'Very High';
            else if (triglycerides > 900) return 'Critical';

        },
        evaluateLDL() {
            const ldl = this.calcularLDL()

            if (ldl < 70) return 'Optimal';
            else if (ldl > 70 && ldl < 100) return 'Optimal';
            else if (ldl > 100 && ldl < 129) return 'Near Optimal';
            else if (ldl > 130 && ldl < 159) return 'Borderline  Hight';
            else if (ldl > 160 && ldl < 189) return 'High';
            else if (ldl > 190) return 'Very High';
        },
        evaluateTotal() {
            const cholesterol = this.convertToNumber(this.fields.cholesterol);
            const cholesterolhdl = this.convertToNumber(this.fields.cholesterolhdl);
            let total = 0;

            total = cholesterol / cholesterolhdl
            if (total < 3.5) return 'Optimal';
            else if (total > 3.5 && total < 5) return 'Normal';
            else if (total > 5) return 'Abnormal';


        },


        call_Calculate() {
            const age = parseFloat(this.age);
            const cholesterol = parseFloat(this.fields.cholesterol);
            const hdl = parseFloat(this.fields.cholesterolhdl);
            const sbp = parseFloat(this.fields.sbp);
            const sbpTreated = this.sbpTreated
            const smoker = this.smoker ? 1 : 0;
            const diabetes = this.diabetes ? 1 : 0;

            let sex
            let race

            if (this.selectedGender = "M") {
                sex = "Man"
            } else {
                sex = "Woman"
            }
            if (this.etniaid == 2) {
                race = "Black"
            } else if (this.etniaid == 3) {
                race = "White"
            }

            this.calculateAscvdRisk(sex, race, sbpTreated, age, cholesterol, hdl, sbp, smoker, diabetes)

            const risk = this.calculateAscvdRisk(sex, race, sbpTreated, age, cholesterol, hdl, sbp, smoker, diabetes)
            const risk_percent = risk * 100;
            const risk_percent_2_decimals = risk_percent.toFixed(2);  // Aproxima a 2 decimales
            this.ascvdResult = risk_percent_2_decimals
            console.log(race);
            console.log(sex);
            console.log(age);
            console.log(cholesterol);
            console.log(hdl);
            console.log(sbp);
            console.log(sbpTreated);
            console.log(smoker);
            console.log(diabetes);
            console.log(risk_percent_2_decimals);

        },



        calculateAscvdRisk(sex, race, treated_BP, age, cl, HDLC, BP, smoker, diabetes) {
            let coefficients = {};
            let interaction_coefficients = {};
            let baseline_survival;
            let overall_mean_sum;

            if (sex === 'Woman') {
                if (race === "White" || race === "Other") {
                    coefficients = {
                        age: -29.799,
                        cl: 13.540,
                        HDLC: -13.578,
                        BP: treated_BP ? 2.019 : 1.957,
                        smoker: 7.574,
                        diabetes: 0.661
                    };
                    interaction_coefficients = {
                        lnage_x_lnage: 4.884,
                        lnage_x_lncl: -3.114,
                        lnage_x_lnHDCL: 3.149,
                        lnage_x_lnBP: 0,  // igual que en python
                        lnage_x_smoker: -1.665,
                    };
                    baseline_survival = 0.9665;
                    overall_mean_sum = -29.18;
                } else if (race === "Black") {
                    coefficients = {
                        age: 17.114,
                        cl: 0.940,
                        HDLC: -18.920,
                        BP: treated_BP ? 29.291 : 27.820,
                        smoker: 0.691,
                        diabetes: 0.874
                    };
                    interaction_coefficients = {
                        lnage_x_lnage: 0,
                        lnage_x_lncl: 0,
                        lnage_x_lnHDCL: 4.475,
                        lnage_x_lnBP: treated_BP ? -6.432 : -6.087,
                        lnage_x_smoker: 0.691,
                    };
                    baseline_survival = 0.9533;
                    overall_mean_sum = 86.61;
                }
            } else if (sex === "Man") {
                if (race === "White" || race === "Other") {
                    coefficients = {
                        age: 12.344,
                        cl: 11.853,
                        HDLC: -7.990,
                        BP: treated_BP ? 1.797 : 1.764,
                        smoker: 7.837,
                        diabetes: 0.658
                    };
                    interaction_coefficients = {
                        lnage_x_lnage: 0,
                        lnage_x_lncl: -2.664,
                        lnage_x_lnHDCL: 1.769,
                        lnage_x_lnBP: 0,
                        lnage_x_smoker: -1.795,
                    };
                    baseline_survival = 0.9144;
                    overall_mean_sum = 61.18;
                } else if (race === "Black") {
                    coefficients = {
                        age: 2.469,
                        cl: 0.302,
                        HDLC: -0.307,
                        BP: treated_BP ? 1.916 : 1.809,
                        smoker: 0.549,
                        diabetes: 0.645
                    };
                    interaction_coefficients = {
                        lnage_x_lnage: 0,
                        lnage_x_lncl: 0,
                        lnage_x_lnHDCL: 0,
                        lnage_x_lnBP: 0,
                        lnage_x_smoker: 0,
                    };
                    baseline_survival = 0.8954;
                    overall_mean_sum = 19.54;
                }
            }

            // Cálculo de logaritmos naturales
            const ln_age = Math.log(age);
            const ln_cl = Math.log(cl);
            const ln_HDLC = Math.log(HDLC);
            const ln_BP = Math.log(BP);

            // Cálculo de términos de interacción
            const lnage_x_lnage = ln_age * ln_age;
            const lnage_x_lncl = ln_age * ln_cl;
            const lnage_x_lnHDCL = ln_age * ln_HDLC;
            const lnage_x_lnBP = ln_age * ln_BP;
            const lnage_x_smoker = ln_age * smoker;

            // Producto de términos de interacción y sus coeficientes
            const interaction_terms_sum =
                lnage_x_lnage * interaction_coefficients.lnage_x_lnage +
                lnage_x_lncl * interaction_coefficients.lnage_x_lncl +
                lnage_x_lnHDCL * interaction_coefficients.lnage_x_lnHDCL +
                lnage_x_lnBP * interaction_coefficients.lnage_x_lnBP +
                lnage_x_smoker * interaction_coefficients.lnage_x_smoker;

            // Producto de logaritmos naturales y coeficientes
            const ln_x_coefficients_sum =
                ln_age * coefficients.age +
                ln_cl * coefficients.cl +
                ln_HDLC * coefficients.HDLC +
                ln_BP * coefficients.BP +
                smoker * coefficients.smoker +
                diabetes * coefficients.diabetes;

            const individual_sum = ln_x_coefficients_sum + interaction_terms_sum;

            // Cálculo del riesgo ASCVD a 10 años
            const risk = 1 - Math.pow(baseline_survival, Math.exp(individual_sum - overall_mean_sum));

            return risk;
        },

        calculateAscvdRisk2() {
            const age = parseFloat(this.age);
            const cholesterol = parseFloat(this.fields.cholesterol);
            const hdl = parseFloat(this.fields.cholesterolhdl);
            const sbp = parseFloat(this.fields.sbp);
            const sbpTreated = this.sbpTreated ? 1 : 0;
            const smoker = this.smoker ? 1 : 0;
            const diabetes = this.diabetes ? 1 : 0;

            if (!age || !cholesterol || !hdl || !sbp || !this.selectedGender || !this.etniaid) {
                alert('Por favor completa todos los campos necesarios.');
                return;
            }



            if (this.etniaid === 3 && this.selectedGender === 'M') {
                const lnAge = Math.log(age);
                const lnTotalChol = Math.log(cholesterol);
                const lnHDL = Math.log(hdl);
                const lnSBP = Math.log(sbp);

                const f_lnage_x_lnage = 0;
                const f_lnage_x_lncl = -2.664;
                const f_lnage_x_lnHDCL = 1.769;
                const f_lnage_x_lnBP = 0;
                const f_lnage_x_smoker = -1.795;


                const sbpTreated_f = sbpTreated;
                const smoker_f = smoker;
                const diabetes_f = diabetes;

                const lnage_x_lncl = lnAge * lnTotalChol;
                const lnage_x_lnHDCL = lnAge * lnHDL;
                const lnage_x_lnBP = lnAge * lnSBP;
                const lnage_x_smoker = lnAge * smoker_f

                const dato = f_lnage_x_lnage +
                    (lnage_x_lncl * f_lnage_x_lncl) +
                    (lnage_x_lnHDCL * f_lnage_x_lnHDCL) +
                    (lnage_x_lnBP * f_lnage_x_lnBP) +
                    (lnage_x_smoker * f_lnage_x_smoker);


                const riesgo = 1 - Math.pow(0.9144, Math.exp(expresionLarga));
                this.ascvdResult = parseFloat((riesgo * 100).toFixed(2)); // como porcentaje redondeado
            }



            // Aquí van los otros casos (F, etnia 2, etc.) igual que antes...


            // Debug log
            console.log("Edad:", age);
            console.log("Colesterol Total:", cholesterol);
            console.log("Colesterol HDL:", hdl);
            console.log("Presión Sistólica:", sbp);
            console.log("Presión tratada:", sbpTreated);
            console.log("Fumador:", smoker);
            console.log("Diabetes:", diabetes);
            console.log("Género:", this.selectedGender);
            console.log("Etnia ID:", this.etniaid);
            console.log("Resultado ASCVD:", this.ascvdResult + '%');

        }
        ,























    },

    watch: {
        fields: {
            handler: async function () {
                this.diagnosis

            },
            deep: true
        }
    },


    mounted() {
        // Asignar valores desde Vuex a las variables del componente
        this.selectedGender = this.$store.state.user.gender;
        this.age = this.$store.state.user.age;
        this.weight = this.$store.state.user.weight;
        this.height = this.$store.state.user.height;
        this.selectedEthnicity = this.$store.state.user.ethnicity;
        this.etniaid = this.$store.state.user.etniaid
        const savedParams = localStorage.getItem('parametros')
    }

};

</script>

<style scoped>
.botton-ad {
    background-image: url('../../images/bajamicro.jpg');
    /* Cambia a la ruta de tu imagen o GIF */
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 50em;
    /* Altura fija */
    max-width: 100%;
    /* Asegura que no desborde horizontalmente */
    overflow: hidden;
}

.right-ad {
    background-image: url('../../images/izquierda.avif');
    /* Cambia a la ruta de tu imagen o GIF */
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 50em;
    /* Altura fija */
    max-width: 100%;
    /* Asegura que no desborde horizontalmente */
    overflow: hidden;
}

.left-ad {
    background-image: url('../../images/izquierda.avif');
    /* Cambia a la ruta de tu imagen o GIF */
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 50em;
    /* Altura fija */
    max-width: 100%;
    /* Asegura que no desborde horizontalmente */
    overflow: hidden;
}

.banner-card {
    background-image: url('../../images/lipidan.jpeg');
    background-size: cover;
    background-position: center;
    color: white;
}

.banner-overlay {
    background-color: rgba(255, 255, 255, 0.8);
    padding: 16px;
    border-radius: 8px;
}

.flex-container {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.principal {
    flex: 1 0 140px;

}

.right-panel {
    background-color: transparent;
    flex: 1 0 120px;
}






/* Fondo completo para la página */
.cbc-analyzer-container {
    background-image: url('../../images/lipidan.jpeg');
    background-size: cover;
    /* Hace que la imagen de fondo cubra todo el área */
    background-position: center;
    /* Centra la imagen */
    min-height: 100vh;
    /* Hace que la altura mínima sea el 100% de la pantalla */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}



/* Estilos generales de la interfaz */
.cbc-analyzer-container {
    background-color: #f0f0f0;
}

.advertisement {
    background-color: #d3d3d3;
    /*     opacity: 0.2; */
    min-height: 2em;
    text-align: center;
}

.analyzer-card {
    background-color: transparent;
    color: white;
    padding: 20px;


}

/* Estilos del diagrama tipo fishbone */
.fishbone-container {
    position: relative;
    width: 100%;
    height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
    /* background-color: #00aaff; */
    background-image: url('../../images/analyzer_acid.png');
    background-size: 90%;
    background-position: center 50%;
    background-repeat: no-repeat;
    border-radius: 1em;
}

.fishbone-input {
    position: absolute;
    /* width: 80px; */
    text-align: center;
    background-color: white;
    color: grey;
    border-radius: 5%;
    font-weight: 900;
    max-height: 3em;
    min-width: 5.5em;
}

.data-box {
    background-color: white;
    /* Fondo blanco */
    border-radius: 12px;
    /* Bordes redondeados */
    border: 1px solid #374b40;
    /* Borde azul claro */
    margin-bottom: 10px;
    /* Separación entre los cuadros */
    padding: 10px;
    text-align: center;
    max-width: 25em;
    align-items: center
}

/* Estilo para el texto dentro de los cuadros */
.diagnosis-text {
    color: #00aaff;
    /* Color de texto celeste */
    font-weight: bold;
    /* Texto en negrita */
    font-size: 1.2rem;
    /* Aumentar tamaño de la fuente */
}

/* Contenedor donde se encuentra la imagen */
.fishbone-container {
    position: relative;
    width: 100%;
    height: 400px;
    /* Mantén un tamaño adecuado o ajusta */
    background-color: #c5972d;
    /* Opcional, para que puedas ver el área de la imagen */
}

/* Estilo de la imagen */
.analyzer-background {
    position: absolute;
    top: -60px;
    /* La imagen comienza en la parte superior */
    left: 45%;
    /* Centrado horizontalmente */
    transform: translateX(-50%);
    /* Asegura que esté completamente centrada */
    width: 100%;
    /* O puedes ajustar el ancho según sea necesario */
    height: auto;
    /* Mantiene las proporciones de la imagen */
}

.data-card {
    background-color: transparent;
    /* Fondo semi-transparente */
}

/* Media Queries para pantallas más pequeñas */
/* Media Queries para pantallas más pequeñas */
@media(min-width:900px) {

    /* Posicionamiento de cada cuadro de entrada en el diagrama */
    .cholesterol {
        top: 50%;
        left: 25%;
    }

    .cholesterolhdl {
        top: 50%;
        left: 45%;
    }

    .triglycerides {
        top: 50%;
        left: 65%;
    }

    .sbp {
        top: 80%;
        left: 85%;
    }

    .btn {
        top: 1%;
        left: 75%;
        background-color: #adb01bb1;
        /* Color naranja suave */
        border-radius: 20px;
        /* Redondeo de las esquinas */
        color: white;
        /* Color de texto blanco */
        padding: 10px 20px;
        /* Espaciado interno para hacer el botón más grande */
        border: none;
        /* Elimina el borde predeterminado */
        cursor: pointer;
        /* Cambia el cursor a mano al pasar sobre el botón */
        transition: background-color 0.3s ease;
        /* Transición suave en el cambio de color */
    }

    .btn:hover {
        background-color: #FF7F32;
        /* Un naranja más oscuro para el hover */
    }




}

@media (max-width: 900px) {
    .fishbone-container {
        background-image: none;
        /* Solo oculta la imagen de fondo, no el contenedor */
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
        width: 100%;
        height: auto;
        flex-wrap: wrap;
        gap: 8px;

    }

    .fishbone-input {
        position: relative;
        width: 90%;
        margin: 5px 0;
        max-width: 400px;
        margin-left: auto;
        margin-right: auto;
    }


    .flex-container {
        display: flex;
        flex-direction: column;
        /* Cambia a columna */
        align-items: center;
    }

    .principal {
        width: 100%;
    }

    .right-panel {
        width: 100%;
    }

    .advertisement.left-ad {
        order: -1;
        /* Coloca la publicidad izquierda arriba */
    }

    .advertisement.right-ad {
        order: 2;
        /* Coloca la publicidad derecha abajo */
    }

    .logo {
        width: 100px;
        /* Hace el logo más pequeño en pantallas pequeñas */
        margin-left: 0;
        margin-right: auto;
    }

    .advertisement h1 {
        font-size: 1.5em;
        /* Reduce el tamaño del texto en la publicidad */
    }

    .data-card {
        padding: 15px;
    }

    .diagnosis-text {
        font-size: 1rem;
        /* Ajusta el tamaño del texto de diagnóstico */
    }

    .data-box {
        font-size: 0.9em;
        /* Ajusta el tamaño de las cajas de datos */
    }

    .analyzer-card {
        padding: 10px;
    }
}
</style>